import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/dist/query/react";

export const emptySplitApi = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({ baseUrl: "https://sarvadnya-s.onrender.com" }), // https://sarvadnya-s.onrender.com // https://sarvadnya-com.onrender.com
    keepUnusedDataFor: 1,
    tagTypes: ["Category", "Product", "Purchase", "Sale", "Supplier", "Transfer", "Transaction", "Home"],
    endpoints: () => ({}),
})
